import client from "./axiosConfig";

export const getAttendanceList = (params) => {
  const config = {
    url: "/hrms/attendance/",
    method: "GET",
    params,
  };
  const response = client(config);
  return response;
};

export const markAttenadance = (data) => {
  const config = {
    url: "/hrms/attendance/",
    method: "POST",
    data,
  };
  const response = client(config);
  return response;
};

export const backDated = (data) => {
  const config = {
    url: "/hrms/attendance/backdated/",
    method: "POST",
    data,
  };
  const response = client(config);
  return response;
};

export const reviewAttendance = (id, data) => {
  const config = {
    url: `/hrms/attendance/review/${id}/`,
    method: "PATCH",
    data,
  };
  const response = client(config);
  return response;
};

export const getDetailedViewById = (id) => {
  const config = {
    url: `/hrms/attendance/${id}/`,
    method: "GET",
  };
  const response = client(config);
  return response;
};
